/**
 * Created by Ning Jiang on 11/11/2019.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodMultiplierController} from "../../multiplier/DeadwoodMultiplierController";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodStackedWild} from "../../symbols/DeadwoodStackedWild";

export class WildAttentionController extends ReelStopPresentationController {

    private _doReelNudge:boolean[];

    constructor(index:number) {
        super(index, "WildAttention");
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._doReelNudge = data.doReelNudge;
    }

    public onReelBounce(data:IReelStoppedData):void {
        // #98 doReelNudge is enough to show all new W
        if(!this._doReelNudge[data.reelId]) {
            return;
        }

        let wild:DeadwoodStackedWild;
        for(let i:number = 1; i < 5; i++) {
            if(this._gameData!.reels[data.reelId][i].indexOf("W") > -1) {
                wild = <DeadwoodStackedWild>Reels.getSymbol(data.reelId, i - 1);
                if(wild == null) {
                    debugger;
                    throw new Error(`WildAttentionController.onReelBounce(): Cannot find Wild symbol at reel ${data.reelId}`);
                }
                wild.updateMultiplier(1, true, "normal");
                break;
            }
        }
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.WILD_LANDING);
        EventHandler.dispatchEvent(new GameEvent(DeadwoodMultiplierController.ADD_MULTIPLIER));
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }
}